import { useIsMobile } from "@src/appV2/redesign/AppLayout/useResponsive";
import { useIsRedesignEnabled } from "@src/appV2/redesign/hooks/useIsRedesignEnabled";

import { AuthRedirectViewLegacy } from "./AuthRedirectViewLegacy";
import { AuthRedirectViewRedesigned } from "./AuthRedirectViewRedesigned";

type AuthState =
  | "checking-session"
  | "already-authenticated"
  | "confirm"
  | "signing-in"
  | "redirecting"
  | "error"
  | "invalid";

interface AuthRedirectViewProps {
  authState: AuthState;
  error?: string;
  existingEmail?: string;
  magicLinkEmail?: string | null;
  /** Custom-scheme URL to open the native app. Shown on mobile browsers where Universal Links failed. */
  appSchemeUrl?: string;
  onContinue: () => void;
  onSignOutAndContinue: () => void;
  onGoToDashboard: () => void;
}

export function AuthRedirectView(props: AuthRedirectViewProps) {
  const isRedesignEnabled = useIsRedesignEnabled();
  const isMobileViewport = useIsMobile();

  if (isMobileViewport || isRedesignEnabled) {
    return <AuthRedirectViewRedesigned {...props} />;
  }

  return <AuthRedirectViewLegacy {...props} />;
}
